import axios from "axios";
import { get_language } from "../apiConfig";
import { getToken } from "../../localstorage";

const api_get_languages = async () => {
  try {
    const res = await axios.get(get_language, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "kpjhealth",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export { api_get_languages };
